import { Grid } from '@mui/material';
import { ReactElement } from 'react';

interface LayoutCardProps {
    children: ReactElement | ReactElement[];
}

export const LayoutCard: React.FC<LayoutCardProps> = ({ children }) => {
    return (
        <Grid
            container
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '100%',
                paddingTop: '50px',
            }}
        >
            {children}
        </Grid>
    );
};
